import once from 'lodash/once';
import { track } from '../../vendor/splitmetrics-track';



export const EVENT_NAME = 'apple_watch_open';


export default once(() => {
  track(EVENT_NAME, null, { once: true });
});



// WEBPACK FOOTER //
// ./src/lib/track-event/apple-watch-view.js